export class AuditReportUrls {
    public static DOWNLOAD_AUDIT_REPORT = '/api/v1/assistanceapplication/downloadauditreportcsv';
    public static DOWNLOAD_AUDIT_PROGRESS_REPORT = '/api/v1/assistanceapplication/downloadauditprogressreportcsv';
}
